import {Injectable} from "@angular/core";
import {FUIAlertService, FUISpinnersService} from "@fedelta-pos/ui";
import {HttpErrorResponse} from "@angular/common/http";
import {throwError} from "rxjs";

/**
 * Service to handle errors
 */
@Injectable()
export class ErrorHandlerService {

    constructor(private alertService: FUIAlertService,
                private spinnersService: FUISpinnersService) {
    }

    handleError(error: HttpErrorResponse) {
        if (this.spinnersService.isOpen()) {
            this.spinnersService.close();
        }

        console.log(error);
        const code = error.status;
        const message = error.error.message;
        if (code === 403) {
            this.alertService.showError("fhm.common.prompt.notAuthorised.heading",
                "fhm.common.prompt.notAuthorised.message").subscribe(() => {
            });

        } else if (message) {
            this.alertService.showError("fhm.common.prompt.unknownError.heading",
                "'" + message + "'").subscribe(() => {
            });
        } else {
            this.alertService.showError("fhm.common.prompt.unknownError.heading",
                "fhm.common.prompt.unknownError.message").subscribe(() => {
            });
        }

        return throwError(() => error);
    }

    handleErrorResponse(error: any): void {
        if (this.spinnersService.isOpen()) {
            this.spinnersService.close();
        }

        console.log(error);

        if (error.status && error["statusText"] ) {
            const err = error["error"];
            this.handleErrorMessage(error.status, err ? err["message"] : undefined);
        } else {
            this.handleErrorMessage(error["status"], error["message"]);
        }
    }

    private handleErrorMessage(code: number, message: string): void {
        if (code === 403) {
            this.alertService.showError("fhm.common.prompt.notAuthorised.heading",
                "fhm.common.prompt.notAuthorised.message").subscribe(() => {
            });

        } else if (message) {
            this.alertService.showError("fhm.common.prompt.unknownError.heading",
                "'" + message + "'").subscribe(() => {
            });
        } else {
            this.alertService.showError("fhm.common.prompt.unknownError.heading",
                "fhm.common.prompt.unknownError.message").subscribe(() => {
            });
        }

    }


}
